/**
 * Reputation engine — computes user reputation level from credentials.
 * @traces §2.8
 */
const LEVEL_ORDER = ['R0', 'R1', 'R2', 'R3', 'R4', 'R5'];
export function computeReputationLevel(credentials, policy, activityWindows = [], missionComplete = false) {
    const assuranceClasses = new Set();
    for (const vc of credentials) {
        for (const ev of vc.evidence) {
            assuranceClasses.add(ev.assuranceClass);
        }
    }
    let highestLevel = 'R0';
    for (const level of LEVEL_ORDER) {
        const req = resolveRequirements(level, policy);
        if (!req)
            continue;
        if (req.min_credentials !== undefined && credentials.length < req.min_credentials)
            continue;
        if (req.required_assurance_classes) {
            if (!req.required_assurance_classes.every((c) => assuranceClasses.has(c)))
                continue;
        }
        if (req.required_assurance_classes_additional) {
            if (!req.required_assurance_classes_additional.every((c) => assuranceClasses.has(c)))
                continue;
        }
        if (req.proof_of_activity) {
            if (activityWindows.length < req.proof_of_activity.min_time_windows)
                continue;
        }
        if (req.mission_to_transaction && !missionComplete)
            continue;
        highestLevel = level;
    }
    return highestLevel;
}
function resolveRequirements(level, policy, visited = new Set()) {
    if (visited.has(level)) {
        throw new Error(`Cycle detected in reputation policy: ${[...visited, level].join(' -> ')}`);
    }
    visited.add(level);
    const req = policy.levels[level];
    if (!req)
        return null;
    if (!req.extends)
        return req;
    const parentReq = resolveRequirements(req.extends, policy, visited);
    if (!parentReq)
        return req;
    return {
        ...parentReq,
        ...req,
        required_assurance_classes: [
            ...(parentReq.required_assurance_classes ?? []),
            ...(req.required_assurance_classes ?? []),
        ].filter((v, i, a) => a.indexOf(v) === i),
        required_assurance_classes_additional: [
            ...(parentReq.required_assurance_classes_additional ?? []),
            ...(req.required_assurance_classes_additional ?? []),
        ].filter((v, i, a) => a.indexOf(v) === i),
    };
}
